import Palette from '@opsbase/lib-palette';
import useCss from '@opsbase/web-css';
const makeMyClasses = (pdf, pdfDetail) => ({
    coverpage: {
        marginBottom: pdf ? undefined : 32,
        padding: pdf ? 48 : undefined,
        breakAfter: pdfDetail ? 'page' : undefined,
        height: pdfDetail ? '100vh' : undefined,
    },
    fullpage: {
        breakAfter: pdf ? 'page' : undefined,
        height: pdf ? '100vh' : undefined,
        marginBottom: pdf ? undefined : 32,
        padding: pdf ? 24 : undefined,
    },
    page2: {
        breakAfter: pdf ? 'page' : undefined,
        minHeight: pdf ? '100vh' : undefined,
        marginBottom: pdf ? undefined : 32,
        padding: pdf ? 24 : undefined,
    },
    title1: pdf
        ? {
            fontSize: 58,
            fontWeight: 'bold',
            lineHeight: '62px',
            color: Palette.primary.main,
        }
        : {
            fontSize: 36,
            fontWeight: 'bold',
            lineHeight: '40px',
            color: Palette.primary.main,
        },
    title2: pdf
        ? {
            fontSize: 32,
            fontWeight: 'bold',
            lineHeight: '38px',
            color: 'white',
        }
        : {
            fontSize: 18,
            fontWeight: 'bold',
            lineHeight: '24px',
            color: Palette.Black.main,
        },
    title3: pdf
        ? {
            textAlign: 'center',
            padding: 8,
            fontSize: 20,
            fontStyle: 'italic',
            color: Palette.LavendarGrey.main,
            lineHeight: '28px',
        }
        : {
            fontSize: 20,
            fontStyle: 'italic',
            color: Palette.LavendarGrey.main,
            lineHeight: '28px',
        },
    chartTitle: {
        fontSize: 20,
        lineHeight: '24px',
    },
    footer: {
        textAlign: pdf ? 'right' : 'left',
        color: pdf ? 'white' : undefined,
    },
    poweredby: {
        display: pdf ? undefined : 'none',
    },
    heading1: {
        breakBefore: pdf ? 'page' : undefined,
        fontSize: 12,
        fontWeight: 'bolder',
        textTransform: 'uppercase',
        lineHeight: '24px',
        marginTop: 16,
        marginBottom: 4,
        color: Palette.Black.main,
        '& p': {
            fontSize: 12,
        },
    },
    heading1nomargin: {
        fontSize: 12,
        fontWeight: 'bolder',
        textTransform: 'uppercase',
        lineHeight: '24px',
        color: Palette.Black.main,
        '& p': {
            fontSize: 12,
        },
    },
    heading2: {
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: '24px',
        marginTop: 12,
        marginBottom: 4,
        color: Palette.Black.main,
        '& p': {
            fontSize: 12,
        },
    },
    table: {
        pageBreakInside: 'auto',
        width: '100%',
        borderSpacing: 0,
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    row: {},
    heading: {
        margin: 0,
        padding: '12px 16px',
        border: '1px solid ' + Palette.LineGrey.main,
        textAlign: 'left',
        verticalAlign: 'top',
        fontWeight: 'normal',
        '& p': {
            fontSize: 12,
        },
    },
    inlineheading: {
        padding: 0,
        overflow: 'hidden',
        maxHeight: 26,
        minHeight: 26,
        margin: 0,
        fontWeight: 'normal',
        fontSize: 10,
        lineHeight: '13px',
    },
    data: {
        margin: 0,
        position: 'relative',
        padding: '12px 16px',
        border: '1px solid ' + Palette.LineGrey.main,
        textAlign: 'left',
        fontWeight: 'bold',
        overflowWrap: 'break-word',
        wordWrap: 'break-word',
        '& p': {
            fontSize: 12,
        },
    },
    dataphoto: {
        marginRight: 10,
        maxWidth: 120,
        maxHeight: 120,
    },
    info: {
        margin: 0,
        padding: '12px 16px',
        textAlign: 'left',
        color: Palette.PastelBlue.main,
        '& p': {
            fontSize: 12,
        },
    },
    left: {
        borderLeft: '0 !important',
        paddingLeft: 0,
    },
    right: {
        borderRight: '0 !important',
        paddingRight: 0,
    },
    leftright: {
        borderLeft: '0 !important',
        paddingLeft: 0,
        borderRight: '0 !important',
        paddingRight: 0,
    },
});
export function useReportCSS(pdf, pdfDetail = false, otherMaker = () => ({}), titleColor) {
    let result1 = useCss(makeMyClasses, [pdf, pdfDetail]);
    let result2 = useCss(otherMaker, [pdf, titleColor]);
    return { ...result1, ...result2 };
}
export default useReportCSS;
